class Company {
    id = null;
    name = '';
    oib = '';
    emails = [];
    phones = [];
    addresses = [];
    foreign = false;
    oib_label = '';
    note = '';
    active = true;
    documents = [];

    constructor(data, validation = false) {
        for (const [key, value] of Object.entries(data)) {
            this[key] = value;
        }

        if (validation) {
            for (const [key] of Object.entries(this)) {
                this[key] = '';
            }
        }
    }

    Fill(data) {
        for (const [key] of Object.entries(this)) {
            if (data[key] !== undefined) {
                this[key] = data[key];
            }
        }
    }
}

export default Company;
